import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { displayErrorToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { newAuditRequest, newAuditRequestStatus } from '../../../redux/audit/audit.action'
import moment from "moment";
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import Modal from 'react-bootstrap/Modal';

const NewAudit = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { newAuditSuccess, newAuditError, newAuditReqStatus } = useSelector(state => state.audit)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [type, setType] = useState('')
    const [date, setDate] = useState(new Date())
    const [showSuccessModal, setShowSuccessModal] = useState(false)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.NEW_AUDIT, true)
            fetchBusinessList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (newAuditReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            setShowSuccessModal(true)
        } else if (newAuditReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(newAuditError.message)
        }
        if (newAuditReqStatus?.length) {
            dispatch(newAuditRequestStatus(''))
        }
    }, [newAuditSuccess, newAuditError, newAuditReqStatus])

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.NEW_AUDIT) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.NEW_AUDIT, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    const handleSubmitClick = () => {
        if (isEmpty(name)) {
            displayErrorToast('Name cannot be blank')
        } else if (isEmpty(description)) {
            displayErrorToast('Description cannot be blank')
        } else if (isEmpty(type)) {
            displayErrorToast('Type cannot be blank')
        } else if (isEmpty(date)) {
            displayErrorToast('Date cannot be blank')
        } else {
            setLoading(true)
            const data = {
                title: name,
                description: description,
                type: type,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                date: moment(date).utc().format("YYYY-MM-DD hh:mm:ss A")
            }
            dispatch(newAuditRequest(data))
        }
    }

    const clearFields = () => {
        setDate(new Date())
        setDescription('')
        setName('')
        setType('')
        setShowSuccessModal(false)
    }

    const handleNewAuditAddClick = () => {
        setShowSuccessModal(false)
        clearFields()
    }

    const handleGoBack = () => {
        navigate(-1, { replace: true });
    };


    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='New Audit' />
                <CommonFormBorder>
                    <SubTextLabel label='Enter details to add new audit' />
                    <CommonInputFloatFull
                        type='text'
                        id='name'
                        onChange={e => setName(e.target.value)}
                        placeholder='Name'
                        value={name}
                    />
                    <CommonInputFloatFull
                        type='text'
                        id='description'
                        onChange={e => setDescription(e.target.value)}
                        placeholder='Description'
                        value={description}
                        multiline={true}
                        rows={4}
                    />
                    <CommonInputFloatFull
                        type='text'
                        id='type'
                        onChange={e => setType(e.target.value)}
                        placeholder='Type'
                        value={type}
                        isSubtext={true}
                        subText='(Ex. IT, Accounts etc.)'
                    />
                    <div className="as-date-parent-container-full">
                        <FormFieldLabel label='Audit Date' />
                        <DatePicker
                            className="as-date-container"
                            selected={date}
                            minDate={new Date()}
                            onChange={(date1) => {
                                setDate(date1)
                            }}
                            dateFormat="MMMM d, yyyy"
                        />
                    </div>
                    {isLoggedInUserBusiness(user) && <div>
                        <FormFieldLabel label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                        {!isEmpty(selectedBusiness) && <div>
                            <FormFieldLabel label='Select Business Location' />
                            {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                                className='select-full-width-no-border'
                                value={selectedLocation}
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e}
                                options={businessLocationListSuccess.data}
                                placeholder='Select Location'
                                onChange={e => setSelectedLocation(e)} />}
                            {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                        </div>}
                    </div>}
                    <ButtonRow>
                        <CommonButton label='Submit' onClick={() => { handleSubmitClick() }} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowSuccessModal(false) }}
                show={showSuccessModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Success
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="at-success-modal-container">
                        <div className="at-success-img-container">
                            <img src={require('../../../assets/success_tick.png')} className="img" />
                        </div>
                        <div className="at-success-text">{newAuditSuccess?.data?.message}</div>
                        <div className="at-next-task-text">Do you want to add new audit?</div>
                        <div className="at-modal-btn-container">
                            <div className="at-modal-no-btn" onClick={() => { handleGoBack() }}>NO</div>
                            <div className="at-modal-yes-btn" onClick={() => { handleNewAuditAddClick() }}>YES</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default NewAudit